export default __webpack_public_path__ + "static/dash-bg-74e053e208a7e8984f806b39478b727e.png";